export enum ERecouvrement {
    Absent = 0,
    Inferieur1 = 1,
    Entre1Et10 = 2,
    Entre10Et25 = 3,
    Entre25Et75 = 4,
    Superieur75 = 5
}